/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTextPlus = createReactComponent("outline", "text-plus", "IconTextPlus", [["path", { "d": "M19 10h-14", "key": "svg-0" }], ["path", { "d": "M5 6h14", "key": "svg-1" }], ["path", { "d": "M14 14h-9", "key": "svg-2" }], ["path", { "d": "M5 18h6", "key": "svg-3" }], ["path", { "d": "M18 15v6", "key": "svg-4" }], ["path", { "d": "M15 18h6", "key": "svg-5" }]]);

export { IconTextPlus as default };
//# sourceMappingURL=IconTextPlus.mjs.map
